export default __webpack_public_path__ + "static/media/19_header_quotation.c27064e5.png";